module.exports = __webpack_public_path__ + "img/11825383_S.25439531.png";